export const MORSE_MAP = {
    'A': '.-', 'B': '-...', 'C': '-.-.', 'D': '-..', 'E': '.', 'F': '..-.',
    'G': '--.', 'H': '....', 'I': '..', 'J': '.---', 'K': '-.-', 'L': '.-..',
    'M': '--', 'N': '-.', 'O': '---', 'P': '.--.', 'Q': '--.-', 'R': '.-.',
    'S': '...', 'T': '-', 'U': '..-', 'V': '...-', 'W': '.--', 'X': '-..-',
    'Y': '-.--', 'Z': '--..',
    '1': '.----', '2': '..---', '3': '...--', '4': '....-', '5': '.....',
    '6': '-....', '7': '--...', '8': '---..', '9': '----.', '0': '-----',
    '.': '.-.-.-', ',': '--..--', '?': '..--..', "'": '.----.', '!': '-.-.--',
    '/': '-..-.', '(': '-.--.', ')': '-.--.-', '&': '.-...', ':': '---...',
    ';': '-.-.-.', '=': '-...-', '+': '.-.-.', '-': '-....-', '"': '.-..-.',
    '@': '.--.-.', ' ': ' '
};

// Learning order based on the Koch method
export const LEARNING_ORDER = 'KMRSUAPTLOWI.NJEF0Y,VG59Q92H38647'.split('');

export const COMMON_WORDS = [
    "THE", "BE", "TO", "OF", "AND", "A", "IN", "THAT", "HAVE", "I",
    "IT", "FOR", "NOT", "ON", "WITH", "HE", "AS", "YOU", "DO", "AT",
    "THIS", "BUT", "HIS", "BY", "FROM", "THEY", "WE", "SAY", "HER", "SHE",
    "OR", "AN", "WILL", " MY", "ONE", "ALL", "WOULD", "THERE", "THEIR", "WHAT",
    "SO", "UP", "OUT", "IF", "ABOUT", "WHO", "GET", "WHICH", "GO", "ME",
    "WHEN", "MAKE", "CAN", "LIKE", "TIME", "NO", "JUST", "HIM", "KNOW", "TAKE",
    "PEOPLE", "INTO", "YEAR", "YOUR", "GOOD", "SOME", "COULD", "THEM", "SEE", "OTHER",
    "THAN", "THEN", "NOW", "LOOK", "ONLY", "COME", "ITS", "OVER", "THINK", "ALSO",
    "BACK", "AFTER", "USE", "TWO", "HOW", "OUR", "WORK", "FIRST", "WELL", "WAY",
    "EVEN", "NEW", "WANT", "BECAUSE", "ANY", "THESE", "GIVE", "DAY", "MOST", "US",
    // CW Abbreviations
    "QTH", "RST", "QSL", "QRZ", "QSB", "QRN", "QRM", "QRO", "QRP", "QRL",
    "QRQ", "QRS", "QRT", "QRV", "QRX", "QSK", "QSY", "QSO", "73", "88", "BK",
    "SK", "BT", "AR", "KN", "TU", "PSE", "UR", "DX", "CQ", "DE",
    "FB", "OM", "YL", "AGN", "HW", "ES", "R", "K"
];

export const TELEGRAPH_THEMED_WORDS = [
    // Morse & Telegraphy
    "TELEGRAPH", "WIRE", "MORSE", "SIGNAL", "OPERATOR", "STATION", "PADDLE", "KEYER",
    "MESSAGE", "CIRCUIT", "VOLTAGE", "DIT", "DAH", "PROSIGN", "PREFIX", "SUFFIX",
    "CALLSIGN", "BROADCAST", "FREQUENCY", "CARRIER", "RELAY", "SOUNDER", "TICKER",
    "ENCODE", "DECODE", "SIMPLEX", "DUPLEX", "REPEATER", "SPEED", "TIMING", "RHYTHM",
    "KEY", "DOT", "DASH", "DATA", "HAM", "TAPE", "COIL", "OHM", "AMP", "VOLT", "WATT",
    "PLUG",

    // Railroad & Steam
    "RAILROAD", "WHISTLE", "CABOOSE", "THROTTLE", "STEAM", "LINE", "RAILS", "TRACKS",
    "DISPATCH", "LOCOMOTIVE", "ENGINE", "TENDER", "BOXCAR", "FLATCAR", "CONDUCTOR",
    "ENGINEER", "FIREMAN", "DEPOT", "TERMINAL", "JUNCTION", "SIDING", "CROSSING",
    "BRIDGE", "TUNNEL", "TRESTLE", "COUPLER", "BUFFER", "IRONHORSE", "HEADLIGHT",
    "PLATFORM", "REVENUE", "MANIFEST", "BAGGAGE", "EXPRESS",
    "RAIL", "ROAD", "IRON", "FIRE", "COAL", "LINK", "HUB", "NODE", "SPIKE", "TIE", "ROUNDHOUSE",

    // Western / Frontier
    "FRONTIER", "OUTPOST", "WILDWEST", "COWBOY", "SHERIFF", "DEPUTY", "MARSHAL",
    "OUTLAW", "BANDIT", "RANCH", "RANGE", "CATTLE", "STAMPEDE", "CANYON", "DESERT",
    "PRAIRIE", "MOUNTAIN", "VALLEY", "WINDMILL", "TELEGRAPHPOLE", "SADDLE", "SALOON",
    "STAGECOACH", "HORSEBACK", "FRONTIERSMAN", "REVOLVER", "WHISKEY", "GUNSLINGER",
    "WEST", "POST", "POLE", "WOOD", "LAND", "FAST", "SLOW",
    "DOG", "HORSE", "COW", "COYOTE", "WOLF", "COUGAR", "FIRE", "SPARK", "SPUR", "GOLD", "PAN",
    "EAGLE", "CROW", "VULTURE", "CACTUS", "BEANS", "FARM", "DUST", "MOON", "STARS",
    "CAMPFIRE", "SKILLET", "CHUCKWAGON", "GULCH", "MESA", "BOOT", "BANDANA", "HIDEOUT", "JAIL", "PIANO", "MUD", "CHICKEN",
    "GATE", "FENCE", "BARBWIRE",

    // Radio & Electronics
    "ANTENNA", "CABLE", "NETWORK", "BATTERY", "CURRENT", "RESISTOR", "CAPACITOR",
    "INDUCTOR", "TRANSISTOR", "VACUUM", "TUBE", "VALVE", "SOCKET", "PLUG", "JACK",
    "SOLDER", "CIRCUITBOARD", "SCHEMATIC", "DIAGRAM", "HANDBOOK", "AMATEUR",
    "LICENSE", "RESONANCE", "CRYSTAL", "FILTER", "GROUND", "WAVELENGTH", "AMPLITUDE",
    "MODULATION", "OSCILLATOR", "HARMONIC", "IMPEDANCE", "REACTANCE", "AMP",

    // Maritime
    "MARITIME", "VESSEL", "HORIZON", "BEACON", "LANTERN", "NAUTICAL", "VOYAGE",
    "ANCHOR", "HARBOR", "OFFSHORE", "TELEMETRY", "SHIPWRECK", "COMPASS", "SEAFARER",
    "SHIP", "BOAT", "PORT", "DOCK", "WAVE", "TIDE", "RIVER", "STREAM", "CREEK"
];

export const VAPID_PUBLIC_KEY = 'BFCwIX65xqSJ2eGJfEA6t8eCXVeN3pgjqk6TdvAAtootl588-mG9QtWVHHYIWRvL0fhGKo-PpmlndreYKnHgdzpc';
